import { ExpandButton, GenericComponent } from '@gorila-shared-ui/components';
import { Card } from 'baseui/card';
import { forwardRef } from 'react';
import { useStyles } from '../../../hooks/useStyles';

type Props = {
  isExpanded: boolean;
  left: string;
  width: number;
  onToggleExpand: () => void;
};

const ExpandableCard = forwardRef<HTMLDivElement, GenericComponent & Props>(function ExpandableCard(
  { isExpanded, left, onToggleExpand, width, ...props },
  ref
) {
  const { theme, css } = useStyles();

  return (
    <div
      ref={ref}
      className={css({
        left,
        width: `clamp(200px, ${width}px, max(100% - 400px))`,
        bottom: theme.sizing.scale500,
        position: 'absolute',
        top: theme.sizing.scale500,
        transition: 'left 0.3s ease-in-out',
      })}
    >
      <div
        className={css({
          position: 'relative',
          height: '100%',
        })}
      >
        <Card
          {...props}
          overrides={{
            Root: {
              style: {
                height: '100%',
                boxSizing: 'border-box',
                borderTopWidth: '1px',
                borderRightWidth: '1px',
                borderBottomWidth: '1px',
                borderLeftWidth: '1px',
                display: 'flex',
                flexDirection: 'column',
              },
            },
            Contents: {
              style: {
                flex: 1,
                overflow: 'hidden',
              },
            },
            Body: {
              style: {
                height: '100%',
                marginBottom: 0,
              },
            },
          }}
        />
        <ExpandButton
          isExpanded={isExpanded}
          onClick={onToggleExpand}
        />
      </div>
    </div>
  );
});

export default ExpandableCard;
